import { render, staticRenderFns } from "./FormControlMBasketOrdersCustomerEmailMessageId.vue?vue&type=template&id=996f8364"
import script from "./FormControlMBasketOrdersCustomerEmailMessageId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMBasketOrdersCustomerEmailMessageId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports